import { Nullable } from 'legacy/lut/classes/models/utils'
import { FC, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { useGetFormDataField } from 'cng-common/features/form'
import { selectPublishingMode } from 'core/store/selectors/selectPublishingMode'
import { FieldLabel } from 'partner360/components/fieldLabel/FieldLabel'

import { PARTNER_BASIC_INFO_FORM_KEY, partnerBasicInfoFields } from '../../../configs'
import { ApplicableToggle } from '../../applicableToggle/ApplicableToggle'

import { ShowroomsEditMode } from './components/showroomsEditMode/ShowroomsEditMode'
import { ShowroomsReadMode } from './components/showroomsReadMode/ShowroomsReadMode'
import { getShowroomsFieldLabelTranslation } from './helpers/getShowroomsFieldLabelTranslation'

import styles from './Showrooms.module.scss'

interface IShowroomsProps {
  isRetail?: boolean

  isApplicable: boolean
  count: Nullable<number>
  locations: string
}

export const Showrooms: FC<IShowroomsProps> = ({
  isRetail,
  isApplicable: initialApplicableValue,
  count,
  locations,
}) => {
  const isEditMode = useSelector(selectPublishingMode)

  const [formApplicableValue] = useGetFormDataField<boolean>(
    PARTNER_BASIC_INFO_FORM_KEY,
    partnerBasicInfoFields.showroomsIsApplicable
  )

  const isApplicableValue = useMemo(
    () => (isEditMode ? formApplicableValue : initialApplicableValue),
    [isEditMode, formApplicableValue, initialApplicableValue]
  )

  const isHideApplicableLabel = useMemo(() => !!isRetail, [isRetail])

  const showroomsFieldLabel = useMemo(() => {
    return getShowroomsFieldLabelTranslation({
      isRetail,
    })
  }, [isRetail])

  return (
    <div className={styles.root}>
      <div className={styles.row}>
        <div className={styles.labelWrapper}>
          <span className={styles.sectionIcon} aria-hidden="true">
            <i className="kbase kbase-lvl-desktop" />
          </span>
          <FieldLabel labelTranslation={showroomsFieldLabel} />
        </div>
        {isEditMode && (
          <ApplicableToggle
            containerClassName={styles.applicableWrapper}
            isEditMode={isEditMode}
            formKey={PARTNER_BASIC_INFO_FORM_KEY}
            defaultValue={initialApplicableValue}
            field={partnerBasicInfoFields.showroomsIsApplicable}
            isHideLabel={isHideApplicableLabel}
          />
        )}
      </div>
      {!isEditMode && (
        <ShowroomsReadMode
          isApplicable={initialApplicableValue}
          count={count}
          locations={locations}
          isCountEnabled={!isRetail}
        />
      )}
      {isEditMode && (
        <ShowroomsEditMode
          isApplicable={isApplicableValue}
          count={count}
          locations={locations}
          isCountEnabled={!isRetail}
        />
      )}
    </div>
  )
}
